// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "0248f6d2d5415b1b62d04c57a3de4f9924ab6676/" + chunkId + ".js";
};